// Mock data for About Us page

export const aboutData = {
  milestones: [
    {
      year: '2022',
      title: 'bHyyve Founded',
      description: 'Started with a vision to revolutionize service booking in Ontario'
    },
    {
      year: '2023',
      title: 'Reached 5,000 Bookings',
      description: 'Expanded to Toronto, Ottawa, and Mississauga with growing customer base'
    },
    {
      year: '2024',
      title: '10+ Cities Launched',
      description: 'Expanded across Ontario serving major cities and communities'
    },
    {
      year: '2025',
      title: '15,000+ Bookings',
      description: 'Became Ontario\'s fastest-growing service booking platform'
    }
  ],
  cities: [
    { name: 'Toronto', lat: 43.6532, lng: -79.3832, bookings: 4523 },
    { name: 'Ottawa', lat: 45.4215, lng: -75.6972, bookings: 2847 },
    { name: 'Mississauga', lat: 43.5890, lng: -79.6441, bookings: 2156 },
    { name: 'Hamilton', lat: 43.2557, lng: -79.8711, bookings: 1834 },
    { name: 'London', lat: 42.9849, lng: -81.2453, bookings: 1523 },
    { name: 'Kitchener', lat: 43.4516, lng: -80.4925, bookings: 1289 },
    { name: 'Windsor', lat: 42.3149, lng: -83.0364, bookings: 987 },
    { name: 'Vaughan', lat: 43.8361, lng: -79.4983, bookings: 876 },
    { name: 'Markham', lat: 43.8561, lng: -79.3370, bookings: 812 },
    { name: 'Barrie', lat: 44.3894, lng: -79.6903, bookings: 745 },
    { name: 'Brampton', lat: 43.7315, lng: -79.7624, bookings: 698 },
    { name: 'Guelph', lat: 43.5448, lng: -80.2482, bookings: 557 }
  ],
  reviews: [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Toronto Resident',
      rating: 5,
      text: 'bHyyve has completely changed how I book services. Fast, reliable, and the professionals are always top-notch!',
      image: null
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Ottawa Business Owner',
      rating: 5,
      text: 'We use bHyyve for all our office maintenance needs. Saved us so much time and money!',
      image: null
    },
    {
      id: 3,
      name: 'Emma Williams',
      role: 'Mississauga Property Manager',
      rating: 5,
      text: 'Managing 15 properties became effortless with bHyyve. Best platform for reliable service providers.',
      image: null
    },
    {
      id: 4,
      name: 'David Brown',
      role: 'Hamilton Homeowner',
      rating: 5,
      text: 'From plumbing to electrical work, bHyyve connects me with verified professionals every time.',
      image: null
    },
    {
      id: 5,
      name: 'Lisa Anderson',
      role: 'London Small Business',
      rating: 5,
      text: 'The customer support is incredible and the service providers are always punctual and professional.',
      image: null
    },
    {
      id: 6,
      name: 'James Wilson',
      role: 'Kitchener Tech Startup',
      rating: 5,
      text: 'As a busy startup, bHyyve helps us get things done without the hassle. Highly recommend!',
      image: null
    }
  ],
  stats: [
    { value: '15,847+', label: 'Total Bookings' },
    { value: '2,500+', label: 'Service Providers' },
    { value: '12', label: 'Cities Covered' },
    { value: '98%', label: 'Customer Satisfaction' }
  ]
};